import { LocaleMessageObject } from "vue-i18n";
import RS from "@/plugins/i18n/locales/rs";
import EN from "@/plugins/i18n/locales/en";
import MK from "@/plugins/i18n/locales/mk";

export enum LocaleHomeString {
  welcome = "home.welcome",
  channelsListHeading = "home.liveChannelsHeading",
  watchNow = "home.watchNow"
}

export enum LocaleSidebarString {
  home = "sidebar.home",
  channels = "sidebar.channels",
  buffet = "sidebar.buffet",
  settings = "sidebar.settings",
  vod = "sidebar.vod"
}

export enum LocaleDatesFilter {
  today = "buffet.datesFilter.today",
  yesterday = "buffet.datesFilter.yesterday",
  tomorrow = "buffet.datesFilter.tomorrow"
}

export enum LocaleBuffetEPGCardFilter {
  play = "buffet.epgCard.play",
  epg = "buffet.epgCard.epg",
  info = "buffet.epgCard.info"
}

export enum LocaleChannelsPage {
  nowOnTV = "channelsPage.nowOnTV",
  channels = "channelsPage.channels"
}

export enum LocaleChannelsInfoPage {
  play = "channelsPage.infoPage.play"
}

export enum LocaleChannelsPageEpgCard {
  play = "channelsPage.epgCard.play",
  epg = "channelsPage.epgCard.epg",
  info = "channelsPage.epgCard.info"
}

export enum LocaleChannelsPageChannelCard {
  play = "channelsPage.channelCard.play",
  epg = "channelsPage.channelCard.epg",
  add = "channelsPage.channelCard.add"
}

export enum LocaleCategoriesEnum {
  allChannels = "categoriesEnum.allChannels",
  favorites = "categoriesEnum.favorites"
}

export enum LocaleBuffetCategoriesEnum {
  home = "buffetCategoriesEnum.home"
}

export enum LocaleVodPageTypes {
  movies = "vodPage.types.movies",
  tvShows = "vodPage.types.tvShows"
}

export enum LocaleSettingsCardsPersonal {
  logout = "settings.cardsPersonal.logout",
  restart = "settings.cardsPersonal.restart",
  languageHeading = "settings.cardsPersonal.language.heading",
  languageSubHeading = "settings.cardsPersonal.language.subHeading",
  pinHeading = "settings.cardsPersonal.pin.heading",
  pinSubHeading = "settings.cardsPersonal.pin.subHeading"
}

export enum LocaleSettingsCardsOther {
  sortAndLockHeading = "settings.cardsOther.sortAndLock.heading",
  sortAndLockSubHeading = "settings.cardsOther.sortAndLock.subHeading",
  supportHeading = "settings.cardsOther.support.heading",
  supportSubHeading = "settings.cardsOther.support.subHeading",
  supportHeadingRightSideMenu = "settings.cardsOther.support.headingRightSideMenu"
}

export enum LocaleSettingsCardsProfile {
  userHeading = "settings.cardsProfile.user.profile",
  childHeadingPartial = "settings.cardsProfile.user.child",
  addChildHeadingPartial = "settings.cardsProfile.addNew.addChild",
  addChildSubHeading = "settings.cardsProfile.addNew.createNew",
  btnEdit = "settings.cardsProfile.btnEdit",
  btnDelete = "settings.cardsProfile.btnDelete"
}

export enum LocaleSettingsPageTitles {
  settingsHomeTitle = "settings.title",
  settingsHomeSubTitle = "settings.subTitle",
  settingsEditUserTitle = "settings.editUserForm.title",
  settingsEditUserSubTitle = "settings.editUserForm.subTitle",
  settingsSortAndLockTitle = "settings.sortAndLock.title",
  settingsSortAndLockSubtitle = "settings.sortAndLock.subTitle"
}

export enum LocaleSettingsPageSectionTitles {
  settingsProfile = "settings.profileSectionTitle",
  settingsPersonal = "settings.personalSectionTitle",
  settingsOther = "settings.otherSectionTitle"
}

export enum LocaleSettingsRightSideMenu {
  logoutBtn = "settings.rightSideMenu.logoutBtn",
  restartBtn = "settings.rightSideMenu.restartBtn",
  oldPinInput = "settings.rightSideMenu.oldPinInput",
  newPinInput = "settings.rightSideMenu.newPinInput",
  confirmNewPinInput = "settings.rightSideMenu.confirmNewPinInput",
  confirmPinBtn = "settings.rightSideMenu.confirmPinBtn",
  contactUs = "settings.rightSideMenu.contactUs"
}

export enum LocaleSettingsConfirmModal {
  userDelete = "settings.confirmModal.userDelete",
  backToSettings = "settings.confirmModal.backToSettings",
  yes = "settings.confirmModal.yes",
  no = "settings.confirmModal.no"
}

export enum LocaleSettingsPinModal {
  confirmPinText = "settings.pinModal.confirmPinText",
  pinInput = "settings.pinModal.pinInput",
  confirmBtn = "settings.pinModal.confirmBtn"
}

export enum LocaleSettingsPinModal {
  username = "settings.editUserForm.username",
  name = "settings.editUserForm.name",
  lastName = "settings.editUserForm.lastName",
  email = "settings.editUserForm.email",
  phone = "settings.editUserForm.phone",
  oldPass = "settings.editUserForm.oldPass",
  password = "settings.editUserForm.password",
  confirmPass = "settings.editUserForm.confirmPass",
  oldPin = "settings.editUserForm.oldPin",
  pin = "settings.editUserForm.pin",
  confirmPin = "settings.editUserForm.confirmPin",
  saveBtn = "settings.editUserForm.saveBtn"
}

export enum LocaleSettingsSortAndLock {
  cardLock = "settings.sortAndLock.cardLock",
  cardUnlock = "settings.sortAndLock.cardUnlock",
  cardSort = "settings.sortAndLock.cardSort",
  cardAdd = "settings.sortAndLock.cardAdd",
  cardRemove = "settings.sortAndLock.cardRemove"
}

export enum LocaleVodCard {
  play = "vodPage.vodCard.play",
  info = "vodPage.vodCard.info",
  add = "vodPage.vodCard.add"
}

export enum LocaleOverlay {
  backBtn = "overlay.backBtn",
  upcomingEpgItem = "overlay.contentNext.later",
  upcomingVoDItem = "overlay.contentNext.upNext",
  nextEpisodeBtn = "overlay.contentNext.nextEpisodeBtn"
}

export enum Locale {
  EN = "en",
  RS = "rs",
  MK = "mk"
}

export interface AppLocaleMessageObject extends LocaleMessageObject {
  home: {
    welcome: string;
    liveChannelsHeading: string;
    watchNow: string;
  };
  sidebar: {
    home: string;
    channels: string;
    buffet: string;
    settings: string;
    vod: string;
  };
  buffet: {
    datesFilter: {
      today: string;
      yesterday: string;
      tomorrow: string;
    };
    epgCard: {
      play: string;
      epg: string;
      info: string;
    };
  };
  channelsPage: {
    nowOnTV: string;
    channels: string;
    infoPage: {
      play: string;
    };
    epgCard: {
      play: string;
      epg: string;
      info: string;
    };
    channelCard: {
      play: string;
      epg: string;
      add: string;
    };
  };
  categoriesEnum: {
    allChannels: string;
    favorites: string;
  };
  buffetCategoriesEnum: {
    home: string;
  };
  vodPage: {
    types: {
      movies: string;
      tvShows: string;
    };
    vodCard: {
      play: string;
      info: string;
      add: string;
    };
  };
  settings: {
    title: string;
    subTitle: string;
    profileSectionTitle: string;
    personalSectionTitle: string;
    otherSectionTitle: string;
    cardsPersonal: {
      logout: string;
      restart: string;
      language: {
        heading: string;
        subHeading: string;
      };
      pin: {
        heading: string;
        subHeading: string;
      };
    };
    cardsOther: {
      sortAndLock: {
        heading: string;
        subHeading: string;
      };
      support: {
        heading: string;
        subHeading: string;
        headingRightSideMenu: string;
      };
    };
    cardsProfile: {
      btnEdit: string;
      btnDelete: string;
      user: {
        profile: string;
        child: string;
      };
      addNew: {
        addChild: string;
        createNew: string;
      };
    };
    rightSideMenu: {
      logoutBtn: string;
      restartBtn: string;
      oldPinInput: string;
      newPinInput: string;
      confirmNewPinInput: string;
      confirmPinBtn: string;
      contactUs: string;
    };
    confirmModal: {
      userDelete: string;
      backToSettings: string;
      yes: string;
      no: string;
    };
    pinModal: {
      confirmPinText: string;
      pinInput: string;
      confirmBtn: string;
    };
    editUserForm: {
      username: string;
      name: string;
      lastName: string;
      email: string;
      phone: string;
      oldPass: string;
      password: string;
      confirmPass: string;
      oldPin: string;
      pin: string;
      confirmPin: string;
      saveBtn: string;
      title: string;
      subTitle: string;
    };
    sortAndLock: {
      title: string;
      subTitle: string;
      cardLock: string;
      cardUnlock: string;
      cardSort: string;
      cardAdd: string;
      cardRemove: string;
    };
  };
  overlay: {
    backBtn: string;
    contentNext: {
      later: string;
      upNext: string;
      nextEpisodeBtn: string;
    };
  };
}

export const baseMessages: Record<Locale, AppLocaleMessageObject> = {
  [Locale.EN]: EN.BaseMessages,
  [Locale.RS]: RS.BaseMessages,
  [Locale.MK]: MK.BaseMessages
};

export interface LocaleOptions {
  BaseMessages: AppLocaleMessageObject;
}
